var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplatesBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_5377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 3.83301V7.49967C11.3333 7.76489 11.4387 8.01924 11.6262 8.20678C11.8138 8.39432 12.0681 8.49967 12.3333 8.49967H16V13.1663C16 13.52 15.8595 13.8591 15.6095 14.1091C15.3594 14.3592 15.0203 14.4997 14.6667 14.4997H13.3333V15.833C13.3333 16.1866 13.1929 16.5258 12.9428 16.7758C12.6928 17.0259 12.3536 17.1663 12 17.1663H6C5.64638 17.1663 5.30724 17.0259 5.05719 16.7758C4.80714 16.5258 4.66666 16.1866 4.66666 15.833V7.83301C4.66666 7.47939 4.80714 7.14025 5.05719 6.8902C5.30724 6.64015 5.64638 6.49967 6 6.49967H7.33333V5.16634C7.33333 4.81272 7.47381 4.47358 7.72385 4.22353C7.9739 3.97348 8.31304 3.83301 8.66666 3.83301H11.3333ZM7.33333 7.83301H6V15.833H12V14.4997H8.66666C8.31304 14.4997 7.9739 14.3592 7.72385 14.1091C7.47381 13.8591 7.33333 13.52 7.33333 13.1663V7.83301ZM12.6667 3.86167C12.9192 3.91524 13.1508 4.041 13.3333 4.22367L15.6093 6.49967C15.792 6.68216 15.9178 6.91376 15.9713 7.16634H12.6667V3.86167Z",
    fill: "#040815"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_5377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesBlack);
export default __webpack_public_path__ + "static/media/Templates-Black.bbe60453de9444654e208b89460cea9e.svg";
export { ForwardRef as ReactComponent };